export default "__VITE_ASSET__BpRChTdL__"